import uniq from 'utils/uniq';
import { PAGE_OPTION } from './constants';
import { getTemplatePage } from './page';

// Maps each `without*` flag of getPageOptionIds to the page option it excludes.
const EXCLUDABLE_PAGE_OPTIONS = {
  withoutIndex: PAGE_OPTION.INDEX,
  withoutTOC: PAGE_OPTION.TOC,
  withoutRecords: PAGE_OPTION.RECORD,
  withoutPhotos: PAGE_OPTION.PHOTO,
  withoutFamilyTree: PAGE_OPTION.FAMILY_TREE,
  withoutTitle: PAGE_OPTION.TITLE,
  withoutDedication: PAGE_OPTION.DEDICATION,
  withoutDivider: PAGE_OPTION.DIVIDER,
};

export function getPageByOptionId(template, optionId) {
  return template.pages.find((page) => page.optionId === optionId);
}

export function getPageOptionIds(template, flags = {}) {
  const excludedOptionIds = new Set(
    Object.entries(EXCLUDABLE_PAGE_OPTIONS)
      .filter(([flag]) => flags[flag])
      .map(([, optionId]) => optionId),
  );

  const optionIds = [];
  template.pages.forEach((page) => {
    if (page.optionId && !excludedOptionIds.has(page.optionId)) {
      optionIds.push(page.optionId);
    }
  });

  // TODO order
  // Offer TOC as a first option.
  return uniq(optionIds).sort((a) => (a === PAGE_OPTION.TOC ? -1 : 0));
}

export function getPageOptionLabel(optionId = '') {
  const dictionary = {
    [PAGE_OPTION.TOC]: 'Table of Contents',
    [PAGE_OPTION.PHOTO]: 'Photos',
    [PAGE_OPTION.TIMELINE]: 'Person Timelines',
    [PAGE_OPTION.FAMILY_SHEET]: 'Family Group Sheets',
    [PAGE_OPTION.FAMILY_TREE]: 'Family Tree',
    [PAGE_OPTION.RECORD]: 'Record Pages',
    [PAGE_OPTION.TITLE]: 'Title Page',
    [PAGE_OPTION.DEDICATION]: 'Dedication Page',
    [PAGE_OPTION.DIVIDER]: 'Divider Page',
  };

  return dictionary[optionId] ?? optionId.split('-').join(' ');
}

export function getPagesByOptions(template, optionIds) {
  return template.pages.filter((page) => optionIds.indexOf(page.optionId) >= 0);
}

export function getTOCPages(template) {
  return getPagesByOptions(template, [PAGE_OPTION.TOC]);
}

export function getIndexPages(template) {
  return getPagesByOptions(template, [PAGE_OPTION.INDEX]);
}

export function isTOCPage(template, pageId) {
  const templatePage = getTemplatePage(template, pageId, 'pages');
  if (templatePage) {
    return templatePage.optionId === PAGE_OPTION.TOC;
  }

  return false;
}
